import { type HotelRecommendationDto } from '@clients/HotelApi';

export const useSimilarHotels = (
    args: MaybeRefOrGetter<{
        title?: string;
        cityName: string;
        hotelName: string;
        checkIn?: string;
        checkOut?: string;
    }>
) => {
    const hotelModule = useHotelModule();
    const analyticsStore = useAnalyticsStore();
    const router = useRouter();
    const hotelForm = useHotelForm();

    const hotels = ref<HotelRecommendationDto[]>([]);

    const similarHotelSelect = (hotelName: string) => {
        const argValue = toValue(args);
        const { fullPath } = hotelForm.generateViewUrl({
            hotelName,
            cityName: argValue.cityName,
            fromDate: argValue.checkIn,
            toDate: argValue.checkOut,
        });
        const selectedHotelIndex = hotels.value.findIndex(
            ({ englishName }) => englishName === hotelName
        );
        const hotel = hotels.value?.[selectedHotelIndex];
        if (hotel) {
            analyticsStore.trackAll('selected-recommended-hotel', {
                hotel,
                photo: hotel.photos?.[0],
                index: selectedHotelIndex,
            });
            router.push(fullPath);
        }
    };

    watch(
        args,
        async val => {
            const newVal = toValue(val);
            if (newVal.cityName && newVal.hotelName) {
                try {
                    hotels.value = await hotelModule.loadSimilarHotel(
                        toValue(val)
                    );
                    if (hotels.value) {
                        analyticsStore.trackAll(
                            'init-recommended-hotel',
                            analyticsStore.searchResultsAttributes
                        );
                    }
                } catch (e) {
                    reportException(e);
                }
            }
        },
        { immediate: true }
    );

    return { similarHotels: hotels, similarHotelSelect };
};
